module.exports = __webpack_public_path__ + "static/media/New-Contacts.2abb0010.png";